import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Clock, ArrowRight, Flame } from "lucide-react";
import { fetchTeaser } from "../lib/api";

const TeaserBar = () => {
  const [teaser, setTeaser] = useState(null);
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    fetchTeaser().then((t) => setTeaser(t)).catch(() => {});
  }, []);

  useEffect(() => {
    if (!teaser?.reveal_at) return undefined;
    const id = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(id);
  }, [teaser?.reveal_at]);

  if (!teaser) return null;

  const accent = teaser.accent_color || "#d4a04a";
  const target = teaser.reveal_at ? new Date(teaser.reveal_at).getTime() : null;
  const diff = target ? Math.max(0, target - now) : null;

  const d = diff != null ? Math.floor(diff / 86400000) : null;
  const h = diff != null ? Math.floor((diff % 86400000) / 3600000) : null;
  const m = diff != null ? Math.floor((diff % 3600000) / 60000) : null;
  const s = diff != null ? Math.floor((diff % 60000) / 1000) : null;

  const countdownText =
    diff == null
      ? null
      : diff === 0
      ? "ZOJUIST GELANCEERD"
      : d > 0
      ? `OVER ${d}D ${String(h).padStart(2, "0")}U ${String(m).padStart(2, "0")}M`
      : `OVER ${String(h).padStart(2, "0")}:${String(m).padStart(2, "0")}:${String(s).padStart(2, "0")}`;

  return (
    <div
      data-testid="teaser-bar"
      className="relative z-[60] w-full text-[11px] sm:text-xs"
      style={{
        background:
          "linear-gradient(90deg, #050505 0%, #0c0a08 50%, #050505 100%)",
        borderBottom: `1px solid ${accent}55`,
      }}
    >
      {/* faint accent line top */}
      <div
        className="absolute inset-x-0 top-0 h-px opacity-70"
        style={{
          background: `linear-gradient(90deg, transparent 0%, ${accent} 50%, transparent 100%)`,
        }}
      />
      <Link
        to="/#teaser"
        data-testid="teaser-bar-link"
        className="group flex items-center justify-center gap-3 sm:gap-5 px-4 py-2 sm:py-2.5 transition-colors hover:bg-[#0c0a08]"
      >
        <Flame
          size={12}
          className="shrink-0 hidden sm:inline"
          style={{ color: accent }}
        />
        <span
          className="font-mono-x tracking-[0.25em] uppercase shrink-0"
          style={{ color: accent }}
        >
          {teaser.name.toUpperCase()} REVEAL
        </span>
        {countdownText && (
          <span className="hidden sm:inline-flex items-center gap-1.5 font-mono-x tracking-widest text-white">
            <Clock size={11} style={{ color: accent }} />
            {countdownText}
          </span>
        )}
        {countdownText && (
          <span className="sm:hidden font-mono-x tracking-widest text-white tabular-nums">
            {countdownText.replace("OVER ", "")}
          </span>
        )}
        <span
          className="inline-flex items-center gap-1 font-display tracking-widest transition-transform group-hover:translate-x-0.5"
          style={{ color: "#fff" }}
        >
          <span className="hidden sm:inline">MELD JE AAN</span>
          <span className="sm:hidden">DOE MEE</span>
          <ArrowRight size={12} style={{ color: accent }} />
        </span>
      </Link>
    </div>
  );
};

export default TeaserBar;
